import { loadCookie, saveCookie } from 'globals/cookieHelper';
import AppAPI from './../../../../../api';

import { formHasEmailQuestion } from '../../../app/ChatApp/selectors';

export const CHAT_DESCRIBE_SHOW = 'chat-describe-show';
export const CHAT_DESCRIBE_HIDE = 'chat-describe-hide';
export const CHAT_DESCRIBE_EMAIL_SUCCESS = 'chat-describe-email-success';

export const chatDescribeShow = () => {
  return { type: CHAT_DESCRIBE_SHOW };
};

export const chatDescribeHide = () => {
  return { type: CHAT_DESCRIBE_HIDE };
};

export const chatDescribeEmailSuccess = email => {
  saveCookie('d-em', email);
  return { type: CHAT_DESCRIBE_EMAIL_SUCCESS, email };
};

export const handleDescribeUserEmail = email => {
  return dispatch => {
    AppAPI.describeEmail(email).then(() => {
      dispatch(chatDescribeEmailSuccess(email));
      setTimeout(() => dispatch(chatDescribeHide()), 10 * 1000); // Ten seconds
    });
  };
};

export const handleMaybeShowDescribe = () => {
  return (dispatch, getState) => {
    const emailSavedCookie = loadCookie('d-em') || false;
    const shouldCaptureEmail = !AppAPI.customerVerified && !emailSavedCookie && !formHasEmailQuestion(getState());
    if (shouldCaptureEmail) {
      dispatch(chatDescribeShow());
    }
  };
};
